/**
 * 
 * Directive to use on input to disable slider's draggable config
 */


var _module = require('./index');

_module.directive('toggleSliderDraggable', [
    'sliderConfig',
    function(sliderConfig) {
        return {
            restrict: 'A',
            controller: ['$scope', '$element', function($scope, $element) {
                $element.on('focus', function() {
                    $scope.$apply(function() {
                        sliderConfig.disableDrag();
                    });
                });

                $element.on('blur', function () {
                    $scope.$apply(function() {
                        sliderConfig.enableDrag();
                    });
                });
            }]
        };
    }
]);
